import { render, staticRenderFns } from "./learning-strands-rating.vue?vue&type=template&id=21382570&scoped=true&"
import script from "./learning-strands-rating.vue?vue&type=script&lang=js&"
export * from "./learning-strands-rating.vue?vue&type=script&lang=js&"
import style0 from "./learning-strands-rating.vue?vue&type=style&index=0&id=21382570&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21382570",
  null
  
)

export default component.exports